import React, { useState } from 'react';
import classNames from 'classnames';

import ChevronIcon from '@lt/components/icons-react/rebrand/ChevronDown';

import styles from './HotelFAQItem.module.css';
import {
  HOTEL_FAQ_ITEM_BUTTON_TEST_ID,
  HOTEL_FAQ_ITEM_DESCRIPTION_TEST_ID,
  HOTEL_FAQ_ITEM_TEST_ID,
  HOTEL_FAQ_ITEM_TITLE_TEST_ID,
} from './constants';

interface Props {
  title: string;
  isMobile?: boolean;
  description?: string;
}

const HotelFAQItem = ({ title, description, isMobile }: Props) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <div className={styles.container} data-testid={HOTEL_FAQ_ITEM_TEST_ID}>
      <button
        type="button"
        className={classNames(styles.titleContainer, {
          [styles.titleContainerOpen]: isOpened,
        })}
        onClick={() => setIsOpened((prev) => !prev)}
        data-testid={HOTEL_FAQ_ITEM_BUTTON_TEST_ID}
      >
        <span
          className={classNames(styles.title, {
            [styles.mobileTitle]: isMobile,
          })}
          data-testid={HOTEL_FAQ_ITEM_TITLE_TEST_ID}
        >
          {title}
        </span>

        <ChevronIcon
          className={classNames(styles.icon, {
            [styles.rotatedIcon]: isOpened,
          })}
        />
      </button>

      <div
        className={classNames(styles.descriptionContainer, {
          [styles.openedDescriptionContainer]: isOpened,
        })}
        data-testid={HOTEL_FAQ_ITEM_DESCRIPTION_TEST_ID}
      >
        <span
          className={classNames(styles.description, {
            [styles.openedDescription]: isOpened,
          })}
        >
          {description}
        </span>
      </div>
    </div>
  );
};

export default HotelFAQItem;
